export default "__VITE_PUBLIC_ASSET__60d55c8c__"